import { Directive } from '@angular/core';

import { MatterBasePage } from '../../../matter/shared/matter-base';
import { matterAllStatusMixin } from './mixins/matter-status-mixin';
import { PageUiService } from '@safarilaw-webapp/shared/ui-kit/basepage';

@Directive()
export class LpmsAllMatterStatusesBaseComponent<PageServiceType extends PageUiService = PageUiService> extends matterAllStatusMixin(MatterBasePage)<PageServiceType> {
  constructor() {
    super();
  }
}
